import Tile from "../Tile";
import MUIGreyColor from "@mui/material/colors/grey";
import Location from "../../Utility/Crud/Location";
import Region from "../../Utility/Crud/Region";
import PropTypes from "prop-types";
import MainContext from "../../Context/MainContext/MainContext";

export default class TileRegion extends Tile {
  static contextType = MainContext; // For legacy class components

  /**
   * @returns {string} The Location name.
   */
  getTitle() {
    return this.props.location
      ? Location.getDisplayName(this.props.location)
      : "None";
  }

  /**
   * @returns {string} The Region name.
   */
  getSubtitle() {
    return this.props.location && this.props.location.region
      ? Region.getDisplayName(
          this.context.regionsIndexed[this.props.location.regionId],
        )
      : "";
  }

  /**
   * @returns {string} The string to be used by the avatar abbreviation
   * formatter.
   */
  getAvatarString() {
    return this.props.location
      ? Location.getDisplayName(this.props.location)
      : null;
  }

  /**
   * @returns {string} The color of the avatar.
   */
  getAvatarColor() {
    return this.props.location ? Location.getColor() : MUIGreyColor[400];
  }

  /**
   * Renders an icon to represent the avatar if no string is provided.
   */
  renderAvatarIcon() {
    return Location.getIcon();
  }
}
